const removeTooltip = () => {
    document.querySelector('.tooltip') && document.querySelector('.tooltip').remove()
}

export default removeTooltip
